var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C10.6569 6 12 4.65685 12 3C12 1.34315 10.6569 0 9 0C7.34315 0 6 1.34315 6 3C6 4.65685 7.34315 6 9 6Z",
    fill: "#08245C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5C5 6.10457 4.10457 7 3 7C1.89543 7 1 6.10457 1 5C1 3.89543 1.89543 3 3 3C4.10457 3 5 3.89543 5 5Z",
    fill: "#08245C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.490644 12.3257C0.321065 12.2271 0.190213 12.0718 0.132468 11.8843C0.0463562 11.6048 0 11.3078 0 11C0 9.34315 1.34315 8 3 8C3.522 8 4.01287 8.13332 4.4404 8.36777C3.39329 9.39885 2.69414 10.7825 2.53478 12.3267C2.5118 12.5494 2.52139 12.7692 2.55996 12.9809C1.81061 12.9156 1.10861 12.6849 0.490644 12.3257Z",
    fill: "#08245C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4405 12.9809C16.1897 12.9155 16.8915 12.6849 17.5094 12.3257C17.6789 12.2271 17.8098 12.0718 17.8675 11.8843C17.9536 11.6048 18 11.3078 18 11C18 9.34315 16.6569 8 15 8C14.4781 8 13.9873 8.13326 13.5599 8.36762C14.6071 9.39872 15.3063 10.7824 15.4656 12.3267C15.4886 12.5494 15.479 12.7692 15.4405 12.9809Z",
    fill: "#08245C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5C17 6.10457 16.1046 7 15 7C13.8954 7 13 6.10457 13 5C13 3.89543 13.8954 3 15 3C16.1046 3 17 3.89543 17 5Z",
    fill: "#08245C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30383 13.1909C4.10473 13.0106 3.99922 12.7478 4.02679 12.4807C4.28657 9.96329 6.41408 8 9.00015 8C11.5862 8 13.7137 9.96329 13.9735 12.4807C14.0011 12.7478 13.8956 13.0107 13.6965 13.1909C12.4545 14.3152 10.8073 15 9.00015 15C7.19298 15 5.54576 14.3152 4.30383 13.1909Z",
    fill: "#08245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.531b61c9943ca3df4cf1cd468188197b.svg";
export { ForwardRef as ReactComponent };